import { SimpleProduct } from '@msdyn365-commerce/retail-proxy';
import { ICoreContext } from '@msdyn365-commerce/core';
import { IBuyboxAddToCartViewProps, IBuyboxAddToWishlistViewProps, IBuyboxData, IBuyboxViewProps } from '@msdyn365-commerce-modules/buybox';
import { IBuyboxData as IBuyboxDataView } from '../../views/buybox.data';
import { IBuyboxProps } from '../../definition-extensions/buybox.ext.props.autogenerated';
import { Dispatch, SetStateAction } from 'react';

export interface IAddressVerified {
    streetName?: string;
    streetType?: string;
    suite?: string;
    number?: string;
    quadrant?: string;
    isChecked?: boolean;
}
export interface ILegalDescriptionVerified {
    plan?: string;
    block?: string;
    lot?: string;
    isChecked?: boolean;
}
export interface ILegalDescriptionCondoVerified {
    plan?: string;
    unit?: string;
    isChecked?: boolean;
}
export interface ICommunityVerified {
    communityName?: string;
}
export interface IEBPVerified {
    blockProfile?: string;
}
export interface IATSVerified {
    atsValue?: string;
}
export interface IQuadrantVerified {
    quadrant?: string;
}
export interface IServiceAddress {
    streetName?: string;
    streetType?: string;
    suite?: string;
    number?: string;
    quadrant?: string;
}
export interface ILookForVerified {
    lookFor?: string;
    isChecked?: boolean;
}
export interface ISDABForm {
    customerInformation?: ICustomerInformation;
    appelantInformation?: IAppalentInformation;
    appealAgainst?: IAppealAgainst;
    anticipateIssues?: IAnticapteIssues;
    witness?: IBringingWitness;
    isChecked?: true;
}

export interface IRelatedProduct extends SimpleProduct {
    isChecked?: boolean;
}

export interface IAllAddresses {
    propertyType: number;
    serviceAddress: IServiceAddress;
    addressVerified: IAddressVerified;
    lookForVerified: ILookForVerified;
    legalDescriptionVerified: ILegalDescriptionVerified;
    legalDescriptionCondoVerified: ILegalDescriptionCondoVerified;
    sdab: ISDABForm;
    lcsab: ILCSABForm;
    relatedProduct: IRelatedProduct[];
    quadrantVerified?: IQuadrantVerified;
    communityVerified?: ICommunityVerified;
    blockProfileVerified?: IEBPVerified;
    atsVerified?: IATSVerified;
}

export interface IStorageData {
    propertyType: number;
    productName: string;
    address: IAddressVerified;
    lookFor: ILookForVerified;
}
export interface IExtendedSimpleProduct extends SimpleProduct {
    isChecked: boolean;
}
export interface ISearchAddressQuery {
    value: string;
    errorMessage?: string;
    isAddressSelected?: boolean;
}
export interface IRollDataAddress {
    suite: string;
    quadrant: string;
    streetName: string;
    streetType: string;
    number: string;
}
export interface ICartAndActions {
    addToCart?: IBuyboxAddToCartViewProps;
    addToWishlist?: IBuyboxAddToWishlistViewProps | undefined;
    setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
    setSDABModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
    modalOpen: boolean;
    genericModalOpen: boolean;
    setGenericModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
    sdabModalOpen: boolean;
    suite: IFormState;
    addressNumber: IFormState;
    streetName: IFormState;
    streetType: IFormState;
    quadrant: IFormState;
    plan: IFormState;
    block: IFormState;
    lot: IFormState;
    unit: IFormState;
    lookFor: IFormState;
    searchAddressQuery: ISearchAddressQuery;
    propertyType: number;
    ldcPlan: IFormState;
    validated?: any;
    _addToCart?: () => Promise<void>;
    allAddresses: IAllAddresses[];
    errorMessages: string[];
    context: ICoreContext<{
        [x: string]: any;
    }>;
    product: SimpleProduct | undefined;
    isDisabled: boolean;
    setIsDisabled: Dispatch<SetStateAction<boolean>>;
    setSuite: Dispatch<SetStateAction<IFormState>>;
    setAddressNumber: Dispatch<SetStateAction<IFormState>>;
    setStreetName: Dispatch<SetStateAction<IFormState>>;
    setStreetType: Dispatch<SetStateAction<IFormState>>;
    setQuadrant: Dispatch<SetStateAction<IFormState>>;
    setPlan: Dispatch<SetStateAction<IFormState>>;
    setBlock: Dispatch<SetStateAction<IFormState>>;
    setLot: Dispatch<SetStateAction<IFormState>>;
    setUnit: Dispatch<SetStateAction<IFormState>>;
    setLookFor: Dispatch<SetStateAction<IFormState>>;
    setLdcPlan: Dispatch<SetStateAction<IFormState>>;
    setPropertyType: Dispatch<SetStateAction<number>>;
    setErrorMessages: Dispatch<SetStateAction<string[]>>;
    setAllAddresses: Dispatch<SetStateAction<IAllAddresses[]>>;
    setSearchAddressQuery: Dispatch<SetStateAction<ISearchAddressQuery>>;
    removeAddress: (index: number, productIndex: number, inputRef: React.MutableRefObject<HTMLInputElement | null>) => void;
    propertyOnChange: (value: string) => void;
    clearValues: () => void;
}

export interface IFormState {
    value: string;
    errorMessage?: string;
}

export interface IFormInput {
    value: string;
    label: string;
    errorMessage?: string;
    isRequired?: boolean;
    section?: string;
    name?: string;
    errorID?: string;
    type?: string;
    inputWidth?: string;
    isOptionSelected?: boolean;
    shortName?: string;
    documentId?: string;
    [x: string]: string | boolean | undefined;
}

export interface IAppealType extends IFormInput {
    AppealAgainstDevelopment?: string | undefined | boolean;
    AppealAgainstSubDivisionApplication?: string | undefined | boolean;
    AppealAgainstNoticOrder?: string | undefined | boolean;
}

export interface IErrorSummary {
    errorMessage: string;
    section?: string;
}

//LCSAB
export interface ILCSABFormProps {
    isModelOpen: boolean;
    toggleSDABModal: React.Dispatch<React.SetStateAction<boolean>>;
    restProps: React.PropsWithChildren<IBuyboxViewProps & IBuyboxProps<IBuyboxData & IBuyboxDataView>>;
    updateAllAddresses: React.Dispatch<React.SetStateAction<IAllAddresses[]>>;
    addProductToCartWithAttribute: (addresses: IAllAddresses[], context: ICoreContext) => Promise<void>;
    product: SimpleProduct;
}
// interface IAppealType extends IFormInput {
//     AppealAgainstDevelopment?: string | undefined | boolean;
//     AppealAgainstSubDivisionApplication?: string | undefined | boolean;
//     AppealAgainstNoticOrder?: string | undefined | boolean;
// }
export interface IFormRadioSelection {
    value: string;
    errorMessage: string;
    label: string;
    section: string;
}
// interface IFormInput {
//     value: string;
//     label: string;
//     errorMessage: string;
//     isRequired: boolean;
//     section: string;
//     name: string;
//     type: string;
//     inputWidth: string;
//     [x: string]: string | boolean | undefined;
// }
export interface IDateAndReasonForAppeal {
    date: IFormInput;
    reasonForAppeal: IFormInput;
}

export const PERSON_INFO_FIELDS = [
    'email',
    'emailConfirm',
    'address1',
    'address2',
    'city',
    'province',
    'postalCode',
    'dayTimePhoneNumber',
    'secondaryPhoneNumber'
] as const;

export type ILCSABPersonCommonInfo = { [K in typeof PERSON_INFO_FIELDS[number]]: IFormInput };
export interface ILCSABCustomerInformation extends ILCSABPersonCommonInfo {
    firstName: IFormInput;
    lastName: IFormInput;
}
export interface ILCSABAppalentInformation extends ILCSABCustomerInformation {
    municipalAddress: IFormInput;
}
export interface IAppealAgainst {
    appeal: IAppealType;
    reasonOfAppeal: IFormInput; // 2000 characters
    presentationTime: IFormInput;
    usingAgentOrLegalCounsel: IFormInput;
}
export interface IBringingWitness {
    bringingWitness: IFormInput;
    howManyWitness: IFormInput; // if above one is set to YES then show this field
}
export interface IAnticapteIssues {
    isAnticipateIssuesWithYourAppeal: IFormInput;
    isAnticipateIssuesWithYourAppealDescription: IFormInput; // only to ask if above one is set to YES
}
export interface ILCSABAgentInformation extends ILCSABPersonCommonInfo {
    agentName: IFormInput;
}
// interface IErrorSummary {
//     errorMessage: string;
//     section: string;
// }
export interface ILCSABForm {
    customerInformation?: ILCSABCustomerInformation;
    appellantInformation?: ILCSABAppalentInformation;
    usingAgent?: string;
    agentInformation?: ILCSABAgentInformation;
    dateDecisionAndReasonForAppeal?: IDateAndReasonForAppeal;
    categoryAppealType?: string;
    petAppealType?: string;
    remedialType?: string;
    licenseType?: string;
    typeOfLicense?: string;
    // Only for CRT usage
    categoryAppealTypeForCRT?: string;
    isChecked?: boolean;
}

//SDAB
export interface ISDABFormProps {
    isModelOpen: boolean;
    toggleSDABModal: React.Dispatch<React.SetStateAction<boolean>>;
    restProps: React.PropsWithChildren<IBuyboxViewProps & IBuyboxProps<IBuyboxData & IBuyboxDataView>>;
    updateAllAddresses: React.Dispatch<React.SetStateAction<IAllAddresses[]>>;
    addProductToCartWithAttribute: (addresses: IAllAddresses[], context: ICoreContext) => Promise<void>;
    product: SimpleProduct;
}
// interface IAppealType extends IFormInput {
//     AppealAgainstDevelopment?: string | undefined | boolean;
//     AppealAgainstSubDivisionApplication?: string | undefined | boolean;
//     AppealAgainstNoticOrder?: string | undefined | boolean;
// }
// interface IFormInput {
//     value: string;
//     label: string;
//     errorMessage: string;
//     isRequired: boolean;
//     section: string;
//     [x: string]: string | boolean | undefined;
// }
export interface ICustomerInformation {
    firstName: IFormInput;
    lastName: IFormInput;
    email: IFormInput;
    emailConfirm: IFormInput;
    address1: IFormInput;
    address2: IFormInput;
    city: IFormInput;
    province: IFormInput;
    postalCode: IFormInput;
    residentialPhone: IFormInput;
    country: IFormInput; // canada
    municipalAddress: IFormInput;
    otherDocuments: IFormInput;
}
export interface IAppalentInformation {
    firstName: IFormInput;
    lastName: IFormInput;
    agentName: IFormInput;
    email: IFormInput;
    emailConfirm: IFormInput;
    address1: IFormInput;
    address2: IFormInput;
    city: IFormInput;
    province: IFormInput;
    postalCode: IFormInput;
    residentialPhone: IFormInput;
    // useCustomerInformation: boolean; // checkbox
}
export interface IAppealAgainst {
    appeal: IAppealType;
    reasonOfAppeal: IFormInput; // 2000 characters
    presentationTime: IFormInput;
    usingAgentOrLegalCounsel: IFormInput;
}
export interface IBringingWitness {
    bringingWitness: IFormInput;
    howManyWitness: IFormInput; // if above one is set to YES then show this field
}
export interface IAnticapteIssues {
    isAnticipateIssuesWithYourAppeal: IFormInput;
    isAnticipateIssuesWithYourAppealDescription: IFormInput; // only to ask if above one is set to YES
}

// interface IErrorSummary
// {
//     errorMessage: string;
//     section: string;
// }

//Generic Form

// export interface IFormInput {
//     value: string;
//     shortName?: string;
//     documentId?: string;
//     errorMessage?: string;
//     label: string;
//     isOptionSelected: boolean;
// }

export interface IDocumentCartCheck {
    searchKey: string;
    documentId: string;
    propertyType: number;
    documentName?: string;
}
export interface IDocumentsCategroyForm {
    isDCModalOpen: boolean;
    closeDCModal: () => void;
    restProps: React.PropsWithChildren<IBuyboxViewProps & IBuyboxProps<IBuyboxData & IBuyboxDataView>>;
    propertyType: number;
    setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export interface IVerifiedProducts {
    searchKey: string;
    isChecked: boolean;
    documentList: IResponseResult[];
}

export interface IResponseResult {
    documentName?: string;
    documentId?: string;
    isChecked?: boolean;
}

export const enum StatusTypes {
    Success = 200,
    Canceled = 5001,
    IntegrationError = 5002,
    CRTError = 5003,
    NotFound = 404,
    DuplicateInState = 4001,
    DuplicateInCart = 4002
}
